(function (
	global,
	$,
	Modal,
	cookie
) {
	/**
	 * webSCAPE UI pop-up class.
	 */
	class PopUp extends Modal
	{
		/**
		 * Show pop-up on.
		 *
		 * @type  {string}
		 * @since 1.0.0
		 */
		showOn = 'page_load';

		/**
		 * Show again after x minutes.
		 *
		 * @type  {number}
		 * @since 1.0.0
		 */
		showAgainAfter = 1440;

		/**
		 * Pop-up cookie prefix.
		 *
		 * @type  {string}
		 * @since 1.0.0
		 */
		cookiePrefix = 'webscape_popup_';

		/**
		 * @param {string} id
		 * @param {string} showOn
		 * @param {number} showAgainAfter
		 * @param {string} cookiePrefix
		 * @since 1.0.0
		 */
		constructor(id, showOn = 'page_load', showAgainAfter = 1440, cookiePrefix = 'webscape_popup_')
		{
			super(id);

			this.showOn			= showOn;
			this.showAgainAfter = showAgainAfter;
			this.cookiePrefix   = cookiePrefix;

			if ('page_load' === this.showOn) {
				this.show();
			} else if ('exit_intent' === this.showOn) {
				$(document).on('mouseleave', e => {
					if (e.clientY > 0) {
						return;
					}

					this.show();
				});
			}
		}

		/**
		 * @inheritDoc
		 */
		show() {
			// Get last shown date-time from cookie.
			let lastTimeShown = new Date(cookie.get(this.cookiePrefix + this.id));

			// Calculate difference between last shown date-time and current date-time.
			let dateDiff = new Date(lastTimeShown.getTime() + this.showAgainAfter * 60000) - new Date();

			if (dateDiff > 0) {
				let dateDiffMinutes = (dateDiff / 1000) / 60;
				if (dateDiffMinutes > 0) {
					return;
				}
			}

			super.show();
		}

		/**
		 * @inheritDoc
		 */
		close(modal, event)
		{
			super.close(modal, event);
			cookie.set(this.cookiePrefix + this.id, new Date(), 365);
		}
	}

	if (!global.hasOwnProperty('webSCAPE') || undefined === global.webSCAPE) {
		global.webSCAPE = {};
	}

	if (!global.webSCAPE.hasOwnProperty('ui') || undefined === global.webSCAPE.ui) {
		global.webSCAPE.ui = {};
	}

	global.webSCAPE.ui.PopUp = PopUp;

}) (
	window,
	jQuery,
	window.webSCAPE.moduleRegistrar.getModule('webscape-modal').getClass(),
	window.webSCAPE.moduleRegistrar.getInstance('webscape-cookie')
);
